var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onClick}},[(_vm.message)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.displayContent)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }